import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { NotificationBell } from "@/components/NotificationBell";
import { getCartCount } from "@/lib/cart";
import { useEffect, useState } from "react";

interface NavbarIconsProps {
  user: any;
}

export const NavbarIcons = ({ user }: NavbarIconsProps) => {
  const [itemCount, setItemCount] = useState(0);

  useEffect(() => {
    const updateCount = () => setItemCount(getCartCount());
    updateCount();
    
    window.addEventListener("cartUpdated", updateCount);
    window.addEventListener("storage", updateCount);
    window.addEventListener("itemAddedToCart", updateCount);
    
    return () => {
      window.removeEventListener("cartUpdated", updateCount);
      window.removeEventListener("storage", updateCount);
      window.removeEventListener("itemAddedToCart", updateCount);
    };
  }, []);

  return (
    <div className="flex items-center gap-2">
      <Button variant="ghost" size="icon" className="relative" asChild>
        <Link to="/cart">
          <ShoppingCart className="h-5 w-5" />
          {itemCount > 0 && (
            <Badge className="absolute -top-1 -right-1 h-5 w-5 rounded-full p-0 flex items-center justify-center text-xs">
              {itemCount}
            </Badge>
          )}
        </Link>
      </Button>
      
      {user && <NotificationBell />}
    </div>
  );
};
